import { Component, OnDestroy } from '@angular/core';
import { NavController, AlertController, ToastController, ActionSheetController, ModalController, LoadingController, Platform } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../providers/provider';
import { Http } from '@angular/http';
import { Subject } from 'rxjs';

import { CustomerPage } from '../account/customer/customer';
import { SelectShopPage } from '../selectshop/selectshop';
import { SelectDatePage } from '../selectdate/selectdate';
import { MenuPage } from '../menu/menu';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import { Deeplinks } from '@ionic-native/deeplinks';
import { Success } from '../success/success';

import moment from 'moment';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnDestroy {
  barcodePrompt = '<ion-content scrollable="false"><img class="center" src="assets/scanqr.png"></ion-content>';
  token: any;
  version: String = '';
  customerInfo = {};
  private _onDestroy = new Subject();
  selectedLocale = false;

  isPwa = false;
  isCore = false;

  constructor(
    public http: Http,
    public navCtrl: NavController,
    public storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScanner,
    public provider: provider,
    public modalCtrl: ModalController,
    public translateService: TranslateService,
    public loadingCtrl: LoadingController,
    public actionSheetCtrl: ActionSheetController,
    public customizer: CustomizerProvider,
    public platform: Platform,
    private deeplinks: Deeplinks
  ) {

    // blocco tasto indietro
    platform.registerBackButtonAction(() => {
      this.provider.setSelectedLocale(false);
      this.provider.clearApp();
      location.reload();
    });

    this.isPwa = this.customizer.pwaView;
    this.isCore = this.platform.is('core') || (this.customizer.isTotemMode() ? true : false);

    storage.ready().then(() => {
      // storage is ready
      // get cities
      this.provider.getCities();

      this.selectedLocale = provider.getSelectedLocale();

      storage.get('customer').then((customer) => {
        this.customerInfo = JSON.parse(customer);
      });

      storage.get('codSfogliaMenu').then((cod) => {
        if (cod) {
          this.token = cod;
          this.provider.setTable(this.token);
          this.navCtrl.push(MenuPage);
        }
      });

      storage.get('versione').then((value) => {
        if (value) {
          if (value.ios) this.version = "ver. " + value.ios.str
          else if (value.android) this.version = "ver. " + value.android.str
          else this.version = ''
        } else {
          this.version = ''
        }
      })
    });

    platform.ready().then(() => {
      this.deeplinks.routeWithNavController(this.navCtrl,{
        '/positive': Success,
        '/negative': {},
      }).subscribe(
        match => {
          //Successfully matched route

          let toast = this.toastCtrl.create({
            message: match.$link.path === '/positive' ? 'Pagamento effettuato' : 'Pagamento Rifiutato',
            duration: 3000,
            position: 'middle'
          });
          toast.present();
        },
        noMatch => {
          //no matched route
        }
      )
    })
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  select(locale) {
    let shop = locale + '.json';
    this.provider.setSelectedLocale(true);
    this.customizer.loadCustomization(shop);
    this.navCtrl.push(HomePage);
  }

  showAlert(message) {
    this.translateService.get('ERRORE').takeUntil(this._onDestroy).subscribe(msg => {
      let alert = this.alertCtrl.create({
        title: msg.ERRORE,
        message: message,
        buttons: [
          {
            text: 'OK', role: 'cancel', handler: () => {
              location.reload();
            }
          }
        ]
      });
      alert.present();
    });
  }

  processBarcodeReading(barcode: String, message: String) {
    this.provider.clearApp();
    if (barcode.startsWith("http")) {
      if (barcode === 'https://q2w.it/tap-menu' || barcode === 'http://q2w.it/tap-menu') {
        // it's the app qr code
        this.showAlert(message);
      }
      else if (barcode.startsWith('http://q2w.it') || barcode.startsWith('https://q2w.it')) {
        // valid table
        this.provider.getTable(barcode).then(data => {
          this.provider.setTable(data["_body"]);
          this.navCtrl.push(MenuPage);
        });
      }
      else {
        // the url it not mine
        this.showAlert(message);
      }
    }
    else if (barcode != null && barcode.length > 0) {
      this.provider.setTable(barcode);
      this.navCtrl.push(MenuPage);
    }
  }

  goTo(choice) {
    if (choice == 'selforder') {
      if (this.customizer.selfOrderingToken() != null) {
        
          const splitURL = document.URL.split("?");
          const urlData = JSON.parse(window.atob(splitURL[1]));
          const now = moment();
          // handle link expiration
          if (!this.customizer.isTotemMode() && 
                (urlData.d == undefined ||
                moment(now).diff(urlData.d, 'hours') > 1))
              {
                // show alert
                this.expiredLinkAlert();
              }
          else {
            // normal handling of order
            this.provider.setTable(urlData.tableJwt);
            this.provider.setTemporaryCustomer(urlData.customerData);

            this.navCtrl.push(MenuPage);
          }
      }
      else {
        this.alertQR();
      }
    } else {
      this.provider.setSfogliamenu();
      if (this.customizer.readingMenuToken() != null) {
        this.provider.setTable(this.customizer.readingMenuToken());
        this.navCtrl.push(MenuPage);
      }
      else {
        this.alertQR();
      }
    }
  }

  alertQR() {
    this.translateService.get(['ALERTITLE', 'QR_ERRATO', 'QR_MANUAL_TITLE',
      'QR_CANT_READ', 'QR_INSERT_MANUAL', 'PROCEED',
      'ANNULLA']).takeUntil(this._onDestroy).takeUntil(this._onDestroy).subscribe(msg => {
        let alert = this.alertCtrl.create({
          title: msg.ALERTITLE,
          message: this.barcodePrompt,
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
              handler: () => {
                this.barcodeScanner.scan().then((result) => {
                  this.processBarcodeReading(result.text, msg.QR_ERRATO);
                }).catch((error) => {
                  //inserimento manuale
                  const prompt = this.alertCtrl.create({
                    title: msg.QR_MANUAL_TITLE,
                    message: msg.QR_CANT_READ,
                    inputs: [
                      {
                        name: 'text',
                        placeholder: msg.QR_INSERT_MANUAL
                      },
                    ],
                    buttons: [
                      { text: msg.ANNULLA },
                      {
                        text: msg.PROCEED,
                        handler: result => {
                          this.processBarcodeReading(result.text, msg.QR_ERRATO);
                        }
                      }
                    ]
                  });
                  prompt.present();
                });
              }
            }]
        });
        alert.present();
      }, err => {
        console.log(err);
        let toast = this.toastCtrl.create({
          message: this.printErrorText(err._body),
          duration: 3000,
          position: 'middle'
        });
        toast.present();
      });
  }

  /**
 * expiredLinkAlert show the warning with expired link
 */
  expiredLinkAlert() {
    this.translateService.get(['ALERTITLE', 'EXPIRED_LINK', 'ANNULLA'])
    .takeUntil(this._onDestroy).takeUntil(this._onDestroy).subscribe(msg => {
      let alert = this.alertCtrl.create({
        title: msg.ALERTITLE,
        message: msg.EXPIRED_LINK,
        buttons: [
          {
            text: 'ANNULLA',
            role: 'cancel'          
          }]
      });
      alert.present();
    }, err => {
      console.log(err);
      let toast = this.toastCtrl.create({
        message: this.printErrorText(err._body),
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    });
  }
  
  asporto(mode: String = undefined) {
    if (mode !== undefined)
      this.storage.set('modeTakeAwayOrDelivery', mode)
    else
      this.storage.remove('modeTakeAwayOrDelivery')
    
    // handle customization
    if ((mode == 'shop' || mode == undefined) && this.customizer.takeAwayToken() != null) {
      this.provider.setTable(this.customizer.takeAwayToken());
      this.provider.getDataInfo().subscribe(data => {
        console.log(data)
        let settings = JSON.parse((<any>data)._body).settings;
        if(settings.askTimeAtBeginOfOrder && settings.askTimeAtBeginOfOrder !== undefined) {
          this.selectData();
        } else {
          this.navCtrl.push(MenuPage);
        }
      }, err => {
        console.log(err);
        let toast = this.toastCtrl.create({
          message: this.printErrorText(err._body),
          duration: 3000,
          position: 'middle'
        });
        toast.present();
      });
    } else if (mode == 'home' && this.customizer.takeAwayDeliveryToken() != null) {
      this.provider.setTable(this.customizer.takeAwayDeliveryToken());
      this.provider.getDataInfo().subscribe(data => {
        console.log(data)
        let settings = JSON.parse((<any>data)._body).settings;
        if(settings.askTimeAtBeginOfOrder && settings.askTimeAtBeginOfOrder !== undefined) {
          this.selectData();
        } else {
          this.navCtrl.push(MenuPage);
        }
      }, err => {
        console.log(err);
        let toast = this.toastCtrl.create({
          message: this.printErrorText(err._body),
          duration: 3000,
          position: 'middle'
        });
        toast.present();
      });
    } 
    else {
      // normal application flow
      let loading = this.loadingCtrl.create({
        content: '<ion-spinner name="circles"></ion-spinner>'
      });
      let modal = this.modalCtrl.create(SelectShopPage);
      modal.onDidDismiss(data => {
        if (data != undefined) {
          this.provider.getJWTAsporto(data).takeUntil(this._onDestroy).subscribe(jwt => {
            loading.present().then(() => {
              this.provider.setTable((<any>jwt)._body);
              loading.dismiss().then(() => {
                this.provider.getDataInfo().subscribe(data => {
                  this.storage.set('modeTakeAwayOrDelivery', JSON.parse((<any>data)._body).menu.takeAwayOptions)
                  let settings = JSON.parse((<any>data)._body).settings;
                  if(settings.askTimeAtBeginOfOrder && settings.askTimeAtBeginOfOrder !== undefined) {
                    this.selectData();
                  } else {
                    this.navCtrl.push(MenuPage);
                  }
                }, err => {
                    let toast = this.toastCtrl.create({
                      message: this.printErrorText(err._body),
                      duration: 3000,
                      position: 'middle'
                    });
                    toast.present();
                  console.log(err);
                });
              });
            })
          }, err => {
            console.log(err);
            let toast = this.toastCtrl.create({
              message: this.printErrorText(err._body),
              duration: 3000,
              position: 'middle'
            });
            toast.present();
          });
        }
      });
      modal.present();
    }
  }

  printErrorText(code) {
    let message: string;
    this.translateService.get([
      'E1000','E1001','E1002','E1003','E1004','E1005','E1006','E1007','E1008','E1009','E1010','E1011','E1012','E1014'
    ]).takeUntil(this._onDestroy).subscribe((msg) => {
        switch (code) {
          case 'E1000':
            message = msg.E1000;
            break;
          case 'E1001':
            message = msg.E1001;
            break;
          case 'E1002':
            message = msg.E1002;
            break;
          case 'E1003':
            message = msg.E1003;
            break;
          case 'E1004':
            message = msg.E1004;
            break;
          case 'E1005':
            message = msg.E1005;
            break;
          case 'E1006':
            message = msg.E1006;
            break;
          case 'E1007':
            message = msg.E1007;
            break;
          case 'E1008':
            message = msg.E1008;
            break;
          case 'E1009':
            message = msg.E1009;
            break;
          case 'E1010':
            message = msg.E1010;
            break;
          case 'E1011':
            message = msg.E1011;
            break;
          case 'E1012':
            message = msg.E1012;
            break;
          default:
            message = code;
            break;
      }
      this.provider.clearApp();
    });

    return message;
  }

  selectData() {
    let modal = this.modalCtrl.create(SelectDatePage);
    modal.onDidDismiss(data => {
      if (data != undefined) {
        this.storage.set('modeTakeAwayOrDelivery', data.how)
        this.provider.setDateForTakeAwayOrDelivery(data.when);
        this.navCtrl.push(MenuPage, data);
      }
    });
    modal.present();
  }

  customer() {
    this.navCtrl.push(CustomerPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts